import * as React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';

import { formatAsDollars, percentage } from '../../../lib/helpers';
import styles from './styles';

export interface Props {
  classes: any;
  data: any[];
}

export const PriceTrendText = (props: Props) => {
  const d = props.data;
  const lastMonth = d[d.length - 1];
  const priceThisYear = formatAsDollars(lastMonth.priceTrend);
  const priceChange =
    (lastMonth.priceTrend - d[0].priceTrend) / d[0].priceTrend;
  const priceChangePerc = percentage(priceChange);
  const priceVerb = priceChange >= 0 ? 'increase' : 'decrease';

  if (!priceChange) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', margin: '7.5px 0' }}>
      {priceChange >= 0 && <TrendingUp htmlColor="#195A50" />}
      {priceChange < 0 && <TrendingDown htmlColor="#E2658C" />}
      <Typography className={props.classes.trendsText}>
        <strong>{priceChangePerc}</strong> {priceVerb} in price from last year
        to <strong>{priceThisYear}</strong>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(PriceTrendText);
